import Vue from 'vue'

export const SimplertEventBus = new Vue()
